export default "__VITE_ASSET__ghZz8UtU__"